import React, { useEffect, useState } from "react";
import "./Checkout.scss";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { cityList, stateList } from "../../constants/stateCity";
import ConfirmOrder from "../../components/ConfirmOrder/ConfirmOrder";
import { newcolor } from "../../constants/color";

const Checkout = () => {
  // confirm box for cash on delivery
  const handleCODClick = () => {
    const userConfirmed = window.confirm(
      "Are you sure you want to place the order with Cash On Delivery?"
    );
    if (userConfirmed) {
      PlaceOrder("COD");
    }
  };

  // For the confirm order
  const [orderPlaced, setOrderPlaced] = useState(false);

  const handlePlaceOrder = () => {
    setOrderPlaced(true);
    PlaceOrder();
  };

  const tokena = localStorage.getItem("raer_token");
  const userId = localStorage.getItem("raer_id");

  useEffect(() => {
    if (!tokena) {
      navigate("/login");
    }
  }, []);

  const [selectedOption, setSelectedOption] = useState("");
  const [showViaWallet, setShowViaWallet] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [orderNote, setOrderNote] = useState("");
  const [discount_code, setDiscount_code] = useState("");
  const [discount_amount, setDiscount_amount] = useState(0);
  const [finalAmount, setFinalAmount] = useState(0);

  const [product, setProducts] = useState([]);
  const [cartProduct, setCartProduct] = useState([]);
  const [totalPrice, setTotalPrice] = useState([]);
  const [walletAmount, setWalletAmount] = useState(0);
  const [isTermsChecked, setIsTermsChecked] = useState(false);
  const [cartId, setCartId] = useState("");

  // coupon states
  const [showCouponList, setShowCouponList] = useState(false);
  const [couponApplied, setCouponApplied] = useState(false);
  const [selectedCouponCode, setSelectedCouponCode] = useState("");
  const [appliedCouponCode, setAppliedCouponCode] = useState("");
  const [couponError, setCouponError] = useState("");
  const [couponList, setCouponList] = useState([
    {
      couponId: 1,
      code: "FIRST20",
      description: "Get 20% off on your first purchase above Rs. 999",
    },
  ]);
  //done
  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  const toggleViaWallet = () => {
    if (!showViaWallet) {
      setShowViaWallet(true);
      setFinalAmount((prev) => {
        if (finalAmount - walletAmount < 0) {
          return 0;
        } else {
          return finalAmount - walletAmount;
        }
      });
    } else {
      setFinalAmount(totalPrice);
      setShowViaWallet(false);
    }
    console.log(finalAmount);
  };

  const navigate = useNavigate();

  const [userData, setUserData] = useState({
    fullName: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    landmark: "",
    state: "",
    pincode: "",
    company: "",
    coupon: appliedCouponCode,
  });

  // write the coupon discount concept here
  const applyCoupon = async () => {
    // Find the coupon that matches the entered code
    const selectedCoupon = applicableCoupons.find(
      (coupon) => coupon.code === selectedCouponCode
    );

    setDiscount_code(selectedCouponCode);
    if (selectedCoupon) {
      // Calculate the discount based on the coupon's discountPercent

      const discountPercent = selectedCoupon.discountPercent;
      const discountAmount = (totalPrice * discountPercent) / 100;
      const finalAmount = totalPrice - discountAmount;

      setDiscount_amount(discountAmount);

      // Update the state with the discounted amount and applied coupon code
      setDiscount_percentage(discountPercent);
      setFinalAmount(finalAmount);
      setCouponApplied(true);
      setAppliedCouponCode(selectedCouponCode);

      // Display a success toast
      toast.success(
        `Coupon applied successfully! You've saved ${discountPercent}% on your purchase.`,
        {
          position: "bottom-right",
          autoClose: 3000,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
        }
      );
    } else {
      // If coupon code is invalid, show a warning toast
      toast.warning("Enter a valid coupon code.", {
        position: "bottom-right",
        autoClose: 3000,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
      });
    }
  };

  const [applicableCoupons, setApplicableCoupons] = useState([]);
  const [nonApplicableCoupons, setNonApplicableCoupons] = useState([]);

  const [discount_percentage, setDiscount_percentage] = useState(0);

  const getTokenData = () => {
    const config = {
      url: process.env.REACT_APP_BASE_URL + `api/getDiscountCoupons`,
      method: "post",
      data: {
        userId: userId,
        amount: totalPrice,
      },
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Hello");
        if (response?.data?.status == true) {
          const applicableData = response?.data?.data?.applicableCoupons;
          console.log(applicableData);
          const notapplicableData = response?.data?.data?.nonApplicableCoupons;
          console.log(notapplicableData);
          setNonApplicableCoupons(notapplicableData);
          setApplicableCoupons(applicableData);
        }
        if (response?.data?.status == false) {
          if (response?.data?.response_code == 500) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          } else if (response?.data?.response_code == 404) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          // toast.error("Your token is expired. Please login again.", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        } else {
          // toast.warn("Problem With Data Fetching", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
      });
  };

  const [cities, setCities] = useState([]);

  const getUserData = () => {
    const config = {
      url: process.env.REACT_APP_BASE_URL + `auth/user/${userId}`,
      method: "get",
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Hello");
        console.log(response?.data?.data);
        if (response?.data?.status == true) {
          const {
            fullName,
            email,
            phone,
            address,
            city,
            landmark,
            state,
            pincode,
          } = response?.data?.data;
          setUserData({
            fullName,
            email,
            phone,
            address,
            city,
            landmark,
            state,
            pincode,
          });
          setShippingUserData({
            fullName,
            email,
            phone,
            address,
            city,
            landmark,
            state,
            pincode,
          });
        }
        if (response?.data?.status == false) {
          if (response?.data?.response_code == 500) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          } else if (response?.data?.response_code == 404) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          // toast.error("Your token is expired. Please login again.", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        } else {
          // toast.warn("Problem With Data Fetching", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
      });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUserData({
      ...userData,
      [name]: value,
    });

    if (name === "state") {
      // Update city options based on selected state
      setCities(cityList[value] || []);
      // Clear selected city if state changes
      setUserData({
        ...userData,
        state: value,
        city: "", // Reset city when state changes
      });
    }
  };

  const getCartProductDetails = () => {
    const config = {
      url: process.env.REACT_APP_BASE_URL + `api/getProductsInCart/${userId}`, // this is userId
      method: "get",
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Hello");
        console.log(response?.data?.data?.products);
        console.log(response?.data?.data?.resultOfData[0]);
        if (response?.data?.status == true) {
          setProducts(response?.data?.data?.products);
          setCartProduct(response?.data?.data?.resultOfData[0]?.products);
          setTotalPrice(response?.data?.data?.totalPrice);
          setCartId(response?.data?.data?.resultOfData[0]?._id);
          setFinalAmount(response?.data?.data?.totalPrice);
          getTokenData();
        }
        if (response?.data?.status == false) {
          if (response?.data?.response_code == 500) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          } else if (response?.data?.response_code == 404) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          // toast.error("Your token is expired. Please login again.", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        } else {
          // toast.warn("Problem With Data Fetching", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
      });
  };

  const handleShippingInputChange = (e) => {
    const { name, value } = e.target;
    setShippingUserData({
      ...userData,
      [name]: value,
    });
  };

  const getWalletAmount = () => {
    const config = {
      url: process.env.REACT_APP_BASE_URL + `api/getWalletById/${userId}`,
      method: "get",
    };

    axios
      .request(config)
      .then((response) => {
        console.log(response?.data);
        if (response?.data?.status == true) {
          setWalletAmount(response?.data?.data?.amount);
        }
        if (response?.data?.status == false) {
          if (response?.data?.response_code == 500) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          } else if (response?.data?.response_code == 404) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          // toast.error("Your token is expired. Please login again.", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        } else {
          // toast.warn("Problem With Data Fetching", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
      });
  };

  const [userShippingData, setShippingUserData] = useState({
    fullName: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    landmark: "",
    state: "",
    pincode: "",
    company: "",
  });

  const validateUserData = () => {
    const { email, phone, pincode, address } = userData;

    // Email validation (simple regex for basic validation)
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      return "Enter valid email Id.";
    }

    // Phone number validation (should be 10 digits)
    const phoneRegex = /^\d{10}$/;
    if (!phoneRegex.test(phone)) {
      return "Phone number should be 10 digits.";
    }

    // Pincode validation (should be 6 digits)
    const pincodeRegex = /^\d{6}$/;
    if (!pincodeRegex.test(pincode)) {
      return "Pincode should be 6 digits.";
    }

    // Address validation (should be more than 25 characters)
    if (address?.length < 25) {
      return "For a valid address, please include more information.";
    }

    return "";
  };

  const PlaceOrder = () => {
    if (!isTermsChecked) {
      toast.success("Select term and conditions", {
        position: "bottom-right",
        autoClose: 4000,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
      });
      return;
    }

    // console.log(userData);

    const errors = validateUserData();

    if (errors) {
      toast.success(errors, {
        position: "bottom-right",
        autoClose: 4000,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
      });
      return;
    }
    if (
      !userData.fullName ||
      !userData.email ||
      !userData.phone ||
      !userData.address ||
      !userData.city ||
      !userData.state ||
      !userData.pincode
    ) {
      toast.success("Fill Every Start field", {
        position: "bottom-right",
        autoClose: 4000,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
      });
      return;
    }

    const config = {
      url: process.env.REACT_APP_BASE_URL + `api/placeOrder`, // this is userId
      method: "post",
      data: {
        products: product,
        userId: userId,
        shippingAddress: userShippingData,
        billing_details: userData,
        pay_by_wallet: totalPrice - finalAmount,
        discount_code,
        discount_amount,
        pay_by_phonePay: paymentMethod == "CashOnDelivery" ? 0 : finalAmount,
        total_amount: totalPrice,
        orderNote,
        cartId,
        discount_percentage,
        wayOfOrder: paymentMethod == "CashOnDelivery" ? "COD" : "Prepaid",
      },
    };

    axios
      .request(config)
      .then((response) => {
        console.log(response?.data?.data);
        if (response?.data?.status == true) {
          if (response?.data?.response_code == 200) {
            // console.log(response?.data?.paymentUrl);
            window.location.href = response?.data?.paymentUrl;
            // window.location.href =
            //   process.env.REACT_APP_CLIENT_URL + "ConfirmOrder";
          }
          if (response?.data?.response_code == 202) {
            console.log(response?.data?.data);

            window.location.href =
              process.env.REACT_APP_CLIENT_URL + "ConfirmOrder";
          }
        }
        if (response?.data?.status == false) {
          if (response?.data?.response_code == 500) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          } else if (response?.data?.response_code == 404) {
            // toast.error("Problem With Data Fetching", {
            //   position: "bottom-right",
            //   autoClose: 4000,
            //   pauseOnHover: true,
            //   draggable: true,
            //   theme: "light",
            // });
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code == 401) {
          // toast.error("Your token is expired. Please login again.", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        } else {
          // toast.warn("Problem With Data Fetching", {
          //   position: "bottom-right",
          //   autoClose: 4000,
          //   pauseOnHover: true,
          //   draggable: true,
          //   theme: "light",
          // });
        }
      });
  };

  const [paymentMethod, setPaymentMethod] = useState(""); // State to hold the selected payment method

  const handlePaymentChange = (event) => {
    setPaymentMethod(event.target.value); // Update state with the selected payment method
  };

  useEffect(() => {
    getUserData();
    getCartProductDetails();
    getWalletAmount();
  }, []);

  const checkDataCoupanCode = () => {
    if (selectedCouponCode) {
      setShowCouponList(false);
      applyCoupon();
    } else {
      toast.warn("You need to enter a coupon code to apply.", {
        position: "bottom-right",
        autoClose: 4000,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
      });
    }
  };

  console.log(applicableCoupons);
  return (
    <div>
      <div className="checkout-main">
        <div className="checkout-outer">
          <div className="checkout-inner row">
            <div className="section-1 col-5">
              <div className="section-outer">
                <div className="head">
                  <h6>Billing details</h6>
                </div>

                <div className="body">
                  <div className="personal-details-container single-container">
                    <p>Personal Details</p>

                    <div className="name row">
                      <div className="sub-name-inner">
                        <p>Full Name</p>
                        <input
                          type="text"
                          name="fullName"
                          value={userData.fullName}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>

                    <div className="company">
                      <div className="name-inner">
                        <p>Company name (optional)</p>
                        <input
                          type="text"
                          name="company"
                          value={userData.company}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>

                    <div className="contact-container">
                      <div className="name-inner">
                        <p>Phone *</p>
                        <input
                          type="text"
                          name="phone"
                          value={userData.phone}
                          onChange={handleInputChange}
                          required
                          placeholder="Enter PhoneNumber"
                        />
                      </div>

                      <div className="name-inner">
                        <p>Email address *</p>
                        <input
                          type="text"
                          name="email"
                          value={userData.email}
                          onChange={handleInputChange}
                          required
                          placeholder="Enter Email"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="billing-details-container single-container">
                    <p>Billing Details</p>

                    <div className="name-inner">
                      <p>Street address *</p>
                      <input
                        type="text"
                        name="address"
                        value={userData.address}
                        onChange={handleInputChange}
                        required
                        placeholder="Enter Address"
                      />
                    </div>

                    <div className="country">
                      <div className="country-div">
                        <p>Country / Region *</p>
                        <p className="india">India</p>
                      </div>

                      <div className="name-inner">
                        <p>State *</p>

                        <select
                          id="state"
                          name="state"
                          value={userData.state}
                          onChange={handleInputChange}
                        >
                          <option value="">Select a state</option>
                          {stateList.map((state) => (
                            <option key={state} value={state}>
                              {state}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="city-pin-container">
                      <div className="name-inner">
                        <p>Town / City *</p>

                        {/* <select
                          id="city"
                          name="city"
                          value={userData.city}
                          onChange={handleInputChange}
                          disabled={!userData.state}
                        >
                          <option value="">Select a city</option>
                          {cities.map((city) => (
                            <option key={city} value={city}>
                              {city}
                            </option>
                          ))}
                        </select> */}
                        <input
                          type="text"
                          name="city"
                          value={userData.city}
                          onChange={handleInputChange}
                          required
                          placeholder="Enter City"
                        />
                      </div>

                      <div className="name-inner">
                        <p>PIN Code *</p>
                        <input
                          type="text"
                          name="pincode"
                          value={userData.pincode}
                          onChange={handleInputChange}
                          required
                          placeholder="Enter Pincode"
                        />
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="ship">
                      <div className="check-inner">
                        <input
                          type="checkbox"
                          name="check"
                          id="shipCheckbox"
                          required
                          checked={isChecked}
                          onChange={handleCheckboxChange}
                        />
                        <label htmlFor="shipCheckbox">
                          Ship to a different address?
                        </label>
                      </div>
                    </div>

                    <div className="message-container">
                      {isChecked && (
                        <div className="body mb-3">
                          {" "}
                          <div className="personal-details-container single-container">
                            <p>Personal Details</p>

                            <div className="name row">
                              <div className="sub-name-inner">
                                <p>Full Name</p>
                                <input
                                  type="text"
                                  name="fullName"
                                  value={userData.fullName}
                                  onChange={handleInputChange}
                                  required
                                />
                              </div>
                            </div>

                            <div className="company">
                              <div className="name-inner">
                                <p>Company name (optional)</p>
                                <input
                                  type="text"
                                  name="company"
                                  value={userData.company}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>

                            <div className="contact-container">
                              <div className="name-inner">
                                <p>Phone *</p>
                                <input
                                  type="text"
                                  name="phone"
                                  value={userData.phone}
                                  onChange={handleInputChange}
                                  required
                                  placeholder="Enter PhoneNumber"
                                />
                              </div>

                              <div className="name-inner">
                                <p>Email address *</p>
                                <input
                                  type="text"
                                  name="email"
                                  value={userData.email}
                                  onChange={handleInputChange}
                                  required
                                  placeholder="Enter Email"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="billing-details-container single-container">
                            <p>Billing Details</p>

                            <div className="name-inner">
                              <p>Street address *</p>
                              <input
                                type="text"
                                name="address"
                                value={userData.address}
                                onChange={handleInputChange}
                                required
                                placeholder="Enter Address"
                              />
                            </div>

                            <div className="country">
                              <div className="country-div">
                                <p>Country / Region *</p>
                                <p className="india">India</p>
                              </div>

                              <div className="name-inner">
                                <p>State *</p>
                                <input
                                  type="text"
                                  name="state"
                                  value={userData.state}
                                  onChange={handleInputChange}
                                  required
                                  placeholder="Enter State"
                                />
                              </div>
                            </div>

                            <div className="city-pin-container">
                              <div className="name-inner">
                                <p>Town / City *</p>
                                <input
                                  type="text"
                                  name="city"
                                  value={userData.city}
                                  onChange={handleInputChange}
                                  required
                                  placeholder="Enter City"
                                />
                              </div>

                              <div className="name-inner">
                                <p>PIN Code *</p>
                                <input
                                  type="text"
                                  name="pincode"
                                  value={userData.pincode}
                                  onChange={handleInputChange}
                                  required
                                  placeholder="Enter Pincode"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="not-ship single-container">
                    <p>Order notes (optional)</p>
                    <textarea
                      type="note"
                      name="check"
                      onChange={(e) => setOrderNote(e.target.value)}
                      rows="5"
                      placeholder="Notes about your order, e.g. special notes for delivery"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>

            <div className="section-2 col-4">
              <div className="section-outer">
                <div className="head">
                  <h6>Your Order</h6>
                </div>

                <div className="body single-container">
                  <div className="product">
                    <p>PRODUCT</p>
                    <p>SUBTOTAL</p>
                  </div>

                  <hr />

                  <div className="name">
                    {cartProduct.map((Itme) => {
                      return (
                        <div className="subname">
                          <p>
                            {Itme?.productId?.productName} - {Itme?.size} -{" "}
                            {Itme?.productId?.color}{" "}
                            <span> × {Itme?.count}</span>
                          </p>
                          <p className="price">
                            {/* ₹{Itme?.productId?.price} */}
                            Rs.{Math.ceil(Itme?.productId?.price || 0)}/-
                          </p>
                        </div>
                      );
                    })}
                  </div>

                  <hr />

                  <div className="subtotal">
                    <p>Sub Total</p>
                    <p className="total-price">₹{Math.ceil(totalPrice)}</p>
                  </div>

                  <div className="subtotal">
                    <p>Shipping Charges</p>
                    <p className="total-price">₹0</p>
                  </div>

                  <hr className="bold-hr" />

                  <div className="subtotal">
                    <p>Total Amount</p>
                    <p className="total-price">₹{Math.ceil(totalPrice)}</p>
                  </div>

                  {/* <hr />
                  <div className="shipping">
                    <h2>Shipping</h2>
                    <div className="check-outer">
                      <div className="check-inner">
                        <input type="radio" name="check" id="" required />
                        <label for="">Free shipping</label>
                      </div>
                      <div className="check-inner">
                        <input type="radio" name="check" id="" required />
                        <label for="">Flat rate:₹150.00</label>
                      </div>
                    </div>
                  </div> */}

                  <hr className="bold-hr" />

                  {/* <div className="last"> */}
                  {/* <div className="check-inner">
                      <input type="checkbox" name="check" id="" required />
                      <label for="">
                        I would like to receive exclusive emails with discounts
                        and product information
                      </label>
                    </div> */}

                  {/* <p>
                      Your personal data will be used to process your order,
                      support your experience throughout this website, and for
                      other purposes described in our privacy policy.
                    </p> */}
                  {/* </div> */}
                </div>

                {/* coupons section */}
                <div className="coupon-container single-container">
                  <div className="coupon-heading">
                    <p>Apply Coupon</p>
                    <p className="tagline">
                      Get extra discount with your order
                    </p>
                  </div>

                  <div className="coupon-input-container">
                    <input
                      type="text"
                      name="coupon"
                      value={selectedCouponCode}
                      onChange={(e) => setSelectedCouponCode(e.target.value)}
                    />
                    <button className="apply-btn" onClick={checkDataCoupanCode}>
                      Apply
                    </button>
                  </div>

                  <p
                    className="showCouponText"
                    onClick={() => setShowCouponList(!showCouponList)}
                  >
                    Show all coupons
                    {showCouponList ? (
                      <i class="bi bi-chevron-up"></i>
                    ) : (
                      <i class="bi bi-chevron-down"></i>
                    )}
                  </p>

                  {showCouponList && (
                    <div className="all-coupons-container">
                      {applicableCoupons?.map((item) => (
                        <div
                          className={`single-coupon-container ${
                            item.code === appliedCouponCode &&
                            "selectedCouponContainer"
                          }`}
                          onClick={() => {
                            setSelectedCouponCode(item.code);
                            setShowCouponList(!showCouponList);
                          }}
                        >
                          <h6>{item.code}</h6>
                          <p>{item.description}</p>
                        </div>
                      ))}
                    </div>
                  )}

                  {couponApplied && (
                    <p className="couponAppliedText">
                      <i class="bi bi-check2-circle"></i>
                      {appliedCouponCode} Coupon Applied
                    </p>
                  )}

                  {couponError && (
                    <p className="couponErrorText">{couponError}</p>
                  )}

                  {couponApplied && (
                    <div className="discounted-amount-container">
                      <p>Discounted Amount: ₹{Math.ceil(discount_amount)}</p>
                    </div>
                  )}
                </div>

                <div className="payment-outer-container single-container">
                  <div className="payment-type-container">
                    <div className="wallet-container">
                      <p>Pay By Wallet</p>

                      <div className="wallet-button">
                        <button onClick={toggleViaWallet}>Wallet</button>
                      </div>
                    </div>

                    {/* <div className="cod-container">
                      <p>Cash On Delivery is Available for This Order</p>
                      <button className="cod-btn" onClick={handleCODClick}>
                        Cash On Delivery
                      </button>
                    </div> */}
                  </div>

                  {showViaWallet && (
                    <>
                      <div className="viawallet">
                        <p>WALLET AMOUNT</p>
                        <p className="wallet-price">{walletAmount}</p>
                      </div>

                      <div className="total">
                        <p>TOTAL</p>
                        <p className="final-price">
                          <span className="total-price1">
                            ₹{Math.ceil(finalAmount)}
                          </span>{" "}
                          (includes <span className="total-price2"> All</span>{" "}
                          Tax)
                        </p>
                      </div>

                      <hr />

                      <div className="text">
                        <p>
                          ₹{walletAmount} WILL BE DEBITED FROM YOUR WALLET AND ₹
                          {Math.ceil(finalAmount - walletAmount)} WILL BE PAID
                          THROUGH OTHER PAYMENT METHOD
                        </p>
                      </div>

                      <hr />
                    </>
                  )}

                  <div className="final-amount-container">
                    <p>Total Amount: ₹{Math.ceil(finalAmount)}</p>
                  </div>
                  <div className="final-amount-container ">
                    {/* <p>Choose Your Payment Method</p> */}
                    {/* <input type="radio" name="pay" /> &nbsp;
                    <label htmlFor="">PhonePay</label>
                    &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                    <input type="radio" name="pay" /> &nbsp;
                    <label htmlFor="">Cash on delivery</label> */}
                    <p className="mt-2">
                      Selected Payment Method :- <i>{paymentMethod} </i>
                    </p>
                    <input
                      type="radio"
                      name="pay"
                      value="CashOnDelivery"
                      checked={paymentMethod === "CashOnDelivery"}
                      onChange={handlePaymentChange}
                    />
                    &nbsp;
                    <label htmlFor="">Cash on Delivery</label>
                    <br />
                    <input
                      type="radio"
                      name="pay"
                      value="PhonePe"
                      checked={paymentMethod === "PhonePe"}
                      onChange={handlePaymentChange}
                    />
                    &nbsp;
                    <label htmlFor="">Online Payment</label>
                  </div>

                  <hr className="bold-hr" />

                  <div className="last">
                    <div className="check-inner">
                      <input
                        type="checkbox"
                        name="check"
                        id="Click_one"
                        required
                        checked={isTermsChecked}
                        onChange={(event) =>
                          setIsTermsChecked(event.target.checked)
                        }
                      />
                      <label htmlFor="Click_one" className="condition">
                        I have read and agree to the website terms and
                        conditions *
                      </label>
                    </div>
                  </div>
                </div>

                <div className="buttonn">
                  <button onClick={() => PlaceOrder()}>Place Order</button>
                  {/* {!orderPlaced ? (
                    <div className="button">
                      <button onClick={handlePlaceOrder}>Place Order</button>
                    </div>
                  ) : (
                    <div className="confrimOrder ">
                      <ConfirmOrder />
                    </div>
                  )} */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Checkout;
